<template>
<div class="ActivityOrder">
    <OrderList :param="param" :flag="flag"></OrderList>
</div>
</template>

<script>
import OrderList from 'views/tools/nationalDistribution/order/OrderList.vue'
export default {
    name: 'ActivityOrder',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                keywords: '',
                username: '',
                chname: this.$route.query.chname ? this.$route.query.chname : '',
                title: this.$route.query.title ? this.$route.query.title : '',
                paytype: '',
                payorderno: '',
                parentnameone: '',
                parentnametwo: ''
            },
            flag: true
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        OrderList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityOrder {
}
</style>
